import React from 'react'

// SVG icons for hazard types — no emojis
const HazardIcon = ({ name }) => {
  const icons = {
    'Flood': (
      <svg width="14" height="14" viewBox="0 0 16 16" fill="none">
        <path d="M1 10 Q4 7 8 10 Q12 13 15 10" stroke="#22d3ee" strokeWidth="1.5" strokeLinecap="round" fill="none"/>
        <path d="M1 13 Q4 10 8 13 Q12 16 15 13" stroke="#22d3ee" strokeWidth="1.5" strokeLinecap="round" fill="none" opacity=".5"/>
        <path d="M8 1 L8 7 M6 4 L8 1 L10 4" stroke="#22d3ee" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
      </svg>
    ),
    'Cyclone / Tropical Storm': (
      <svg width="14" height="14" viewBox="0 0 16 16" fill="none">
        <path d="M8 8 m-5 0 a5 5 0 1 0 10 0" stroke="#22d3ee" strokeWidth="1.5" strokeLinecap="round" fill="none"/>
        <path d="M8 8 m-3 0 a3 3 0 1 1 6 0" stroke="#22d3ee" strokeWidth="1.5" strokeLinecap="round" fill="none" opacity=".6"/>
        <circle cx="8" cy="8" r="1.2" fill="#22d3ee"/>
      </svg>
    ),
    'Extreme Heat': (
      <svg width="14" height="14" viewBox="0 0 16 16" fill="none">
        <circle cx="8" cy="8" r="3" stroke="#f59e0b" strokeWidth="1.5" fill="none"/>
        <line x1="8" y1="1" x2="8" y2="3" stroke="#f59e0b" strokeWidth="1.5" strokeLinecap="round"/>
        <line x1="8" y1="13" x2="8" y2="15" stroke="#f59e0b" strokeWidth="1.5" strokeLinecap="round"/>
        <line x1="1" y1="8" x2="3" y2="8" stroke="#f59e0b" strokeWidth="1.5" strokeLinecap="round"/>
        <line x1="13" y1="8" x2="15" y2="8" stroke="#f59e0b" strokeWidth="1.5" strokeLinecap="round"/>
        <line x1="2.9" y1="2.9" x2="4.3" y2="4.3" stroke="#f59e0b" strokeWidth="1.5" strokeLinecap="round"/>
        <line x1="11.7" y1="11.7" x2="13.1" y2="13.1" stroke="#f59e0b" strokeWidth="1.5" strokeLinecap="round"/>
      </svg>
    ),
    'Wind Storm': (
      <svg width="14" height="14" viewBox="0 0 16 16" fill="none">
        <path d="M1 5 Q5 3 8 5 Q11 7 14 5" stroke="#22d3ee" strokeWidth="1.5" strokeLinecap="round" fill="none"/>
        <path d="M1 9 Q5 7 9 9 Q12 11 15 8" stroke="#22d3ee" strokeWidth="1.5" strokeLinecap="round" fill="none"/>
        <path d="M1 13 Q4 11 7 13" stroke="#22d3ee" strokeWidth="1.5" strokeLinecap="round" fill="none" opacity=".5"/>
      </svg>
    ),
    'Drought': (
      <svg width="14" height="14" viewBox="0 0 16 16" fill="none">
        <circle cx="8" cy="6" r="3.5" stroke="#f59e0b" strokeWidth="1.5" fill="none"/>
        <line x1="8" y1="1" x2="8" y2="2.5" stroke="#f59e0b" strokeWidth="1.5" strokeLinecap="round"/>
        <line x1="2.9" y1="2.9" x2="3.9" y2="3.9" stroke="#f59e0b" strokeWidth="1.5" strokeLinecap="round"/>
        <line x1="1" y1="6" x2="2.5" y2="6" stroke="#f59e0b" strokeWidth="1.5" strokeLinecap="round"/>
        <line x1="13.5" y1="6" x2="15" y2="6" stroke="#f59e0b" strokeWidth="1.5" strokeLinecap="round"/>
        <line x1="12.1" y1="2.9" x2="13.1" y2="3.9" stroke="#f59e0b" strokeWidth="1.5" strokeLinecap="round"/>
        <path d="M5 11 Q5 14 8 14 Q11 14 11 11" stroke="#f59e0b" strokeWidth="1.5" strokeLinecap="round" fill="none" opacity=".4"/>
      </svg>
    ),
    'Sea Level Rise': (
      <svg width="14" height="14" viewBox="0 0 16 16" fill="none">
        <path d="M1 12 Q4 9 8 12 Q12 15 15 12" stroke="#22d3ee" strokeWidth="1.5" strokeLinecap="round" fill="none"/>
        <path d="M3 8 L13 8 M3 4 L9 4" stroke="#22d3ee" strokeWidth="1.5" strokeLinecap="round" opacity=".5"/>
        <path d="M13 1 L13 7 M11 3 L13 1 L15 3" stroke="#ef4444" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" fill="none"/>
      </svg>
    ),
  }
  return icons[name] ?? (
    <svg width="14" height="14" viewBox="0 0 16 16" fill="none">
      <path d="M8 2 L14 13 L2 13 Z" stroke="#f59e0b" strokeWidth="1.5" strokeLinejoin="round" fill="none"/>
      <line x1="8" y1="7" x2="8" y2="10" stroke="#f59e0b" strokeWidth="1.5" strokeLinecap="round"/>
      <circle cx="8" cy="11.5" r=".8" fill="#f59e0b"/>
    </svg>
  )
}

function riskColor(score) {
  if (score < 0.1)  return 'var(--score-excellent)'
  if (score < 0.25) return 'var(--score-good)'
  if (score < 0.5)  return 'var(--score-moderate)'
  if (score < 0.75) return 'var(--score-marginal)'
  return 'var(--score-poor)'
}

export default function ClimateRiskPanel({ climateRisk }) {
  if (!climateRisk) return (
    <div className="card">
      <div className="card__title">Climate Risk</div>
      <div style={{ color: 'var(--text-muted)', fontSize: 12 }}>No climate risk data available.</div>
    </div>
  )

  const score        = climateRisk.climate_risk_score ?? 0
  const hazardDetails = climateRisk.hazard_details ?? []
  const mitigations  = climateRisk.mitigations ?? []

  return (
    <>
      <div className="card">
        <div className="card__title">Climate Risk Score</div>
        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 12 }}>
          <div style={{
            width: 48, height: 48, borderRadius: '50%',
            border: `2px solid ${riskColor(1 - score / 100)}`,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontWeight: 700, fontSize: 16, fontFamily: 'var(--mono)',
            color: riskColor(1 - score / 100),
          }}>
            {Math.round(score)}
          </div>
          <div style={{ fontSize: 12, color: 'var(--text-muted)' }}>
            out of 100 — higher is lower risk
          </div>
        </div>

        {hazardDetails.map(h => (
          <div key={h.name} style={{
            display: 'flex', alignItems: 'center', gap: 8,
            padding: '6px 0', borderBottom: '1px solid var(--border-soft)',
          }}>
            <span style={{ width: 18, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
              <HazardIcon name={h.name} />
            </span>
            <span style={{ flex: 1, fontSize: 12, color: 'var(--text-muted)' }}>{h.name}</span>
            <span style={{
              fontSize: 10, padding: '2px 6px', borderRadius: 4,
              background: 'rgba(255,255,255,.05)',
              color: riskColor(h.score),
              fontWeight: 600,
              letterSpacing: '0.3px',
            }}>
              {h.severity}
            </span>
            <div style={{ width: 48, height: 3, borderRadius: 2, background: 'var(--border)', overflow: 'hidden', flexShrink: 0 }}>
              <div style={{ height: '100%', width: `${h.score * 100}%`, background: riskColor(h.score), borderRadius: 2 }} />
            </div>
          </div>
        ))}
      </div>

      {mitigations.length > 0 && (
        <div className="card">
          <div className="card__title">Risk Mitigations</div>
          <ul className="rec-list">
            {mitigations.map((m, i) => <li key={i}>{m}</li>)}
          </ul>
        </div>
      )}
    </>
  )
}
